<ng-container *ngIf="isServiceUnavailable$ | async">
  <py-alert-message
    [body]="'errors.serviceUnavailable_message' | cxTranslate"
    type="danger"
    [dismissable]="false"
  ></py-alert-message>
</ng-container>
